import React, { Component } from 'react';
import Base from '../../rebase';
import { 
  Table
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import AttributedTextComponent from './Text/AttributedTextComponent';

class AgendaComponent extends Component {

  render() {
    return (
      <Table style={this.props.style}>
      {
        this.props.items.map((item, index) => (
          <tbody>
            <tr Style="border: none;">
              <td Style="border: none;"><AttributedTextComponent text={item.time} style={item.time.style}/></td>
              <td Style="border: none;"><AttributedTextComponent text={item.body} style={item.time.body}/></td>
            </tr>
          </tbody>
        ))
      }
      </Table>
      )
  }
}

export default AgendaComponent;

AgendaComponent.propTypes = {
    items: PropTypes.array.isRequired
}


// WEBPACK FOOTER //
// ./src/reusable_components/page_components/AgendaComponent.jsx